/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState} from 'react';
import {Tag, Tabs, TabsProps} from "antd";
import styles from './UserListPanel.module.scss';
import { User } from "../../../types/User";
import { VerifyStatusType } from "../../../types/Type";
import UserInfoTab from "./UserInfoTab/UserInfoTab";
import UserVerificationTab from "./UserVerificationTab/UserVerificationTab";
import UserBlockTab from "./UserBlockTab/UserBlockTab";
import SubscriptionTab from "./SubscriptionTab/SubscriptionTab";
import UserMannerTab from "./UserMannerTab/UserMannerTab";

export const getBoolVerificationTag = (item: any) => item
	? <Tag color="processing" key="인증">인증</Tag>
	: <Tag color="error" key="미인증">미인증</Tag>;

export const getVerificationTag = (item?: VerifyStatusType) => {
	if (item === 'verified') return <Tag color="processing" key="인증">인증</Tag>;
	if (item === 'review') return <Tag color="default" key="심사 요청">심사 요청</Tag>;
	if (item === 'rejected') return <Tag color="error" key="승인 거절">승인 거절</Tag>;
	if (item === null) return <Tag color="error" key="미인증">미인증</Tag>;
	return null;
};

interface UserListPanelProps {
	shouldUserListPanelRerender: boolean;
	selectedItem: User | undefined;
	afterSubmit: () => any;
	verifyAll: () => any;
}

const UserListPanel = ({ shouldUserListPanelRerender, selectedItem, afterSubmit, verifyAll }: UserListPanelProps) => {
	const tabs: TabsProps['items'] = [
		{
			key: '1',
			label: '회원 정보',
			children: <UserInfoTab selectedItem={selectedItem} />,
		},
		{
			key: '2',
			label: '사업자/차량 인증',
			children: (
				<UserVerificationTab
					verifyAll={verifyAll}
					shouldUserListPanelRerender={shouldUserListPanelRerender}
					selectedItem={selectedItem}
					afterSubmit={afterSubmit}
				/>
			),
		},
		{
			key: '3',
			label: '차단 목록',
			children: (
				<UserBlockTab
					selectedItem={selectedItem}
				/>
			),
		},
		{
			key: '4',
			label: '구독 조회',
			children: (
				<SubscriptionTab
					selectedItem={selectedItem}
				/>
			),
		},
		{
			key: '5',
			label: '매너',
			children: (
				<UserMannerTab
					selectedItem={selectedItem}
				/>
			),
		},
	];

	return (
		<div className={styles.wrap}>
			<Tabs
				size="large"
				defaultActiveKey={(selectedItem?.businessStatus === 'review' || selectedItem?.reviewCount !== "0" ) ? "2" : "1"}
				items={tabs}
				destroyInactiveTabPane
			/>
		</div>
	);
};

export default UserListPanel;
